module.exports = __webpack_public_path__ + "static/media/Inspections.3902d198.svg";